import React, {Component} from 'react';
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {withFirestore, firestoreConnect} from "react-redux-firebase";
import {connect} from "react-redux";
import {UserIsAuthenticated} from "../../utils/AuthManager";
import {StyledButton} from "../../components/Buttons";
import withSubscriptionValidatorHoc from "../../components/auth/SubscriptionValidatorHOC";
import {CALL_DB_PATH} from "../../constants/DB_PATHS";
import {BackgroundDiv} from "../../components/Containers";
import Navbar from "../../components/Navbar";

class ActiveCalls extends Component {
    render() {
        return (
            <div>
                <BackgroundDiv/>
                <Navbar/>
                <h2>Active calls</h2>
                {this.props.calls && this.props.calls.length !== 0 ?
                    <ul>
                        {this.props.calls.map((e, i) => {
                            console.log(e)
                            if(e.takenByCompany == null){
                                return (
                                    <li key={i}>
                                        <div>
                                            {e.info[0].address &&
                                            e.info[0].address.formatted_address ?
                                                e.info[0].address.formatted_address : e.info[0].address }
                                        </div>
                                        <div>Caller:
                                            {e.info && e.info[5] ?
                                                <span>{e.info[5].firstN} {e.info[5].lastN}</span>
                                            :
                                                null
                                            }

                                        </div>
                                        <div>Active: {e.active ? 'yes' : 'no'}</div>
                                        <div>Taken: {e.taken ? 'yes' : 'no'}</div>
                                        <div>{e.takeBy ? e.takeBy : 'not taken'}</div>
                                        <div>id: {e.id}</div>
                                        <button onClick={()=>{
                                            console.log(this.props.auth)
                                            this.props.firestore.collection('calls').doc(e.id)
                                                .update({
                                                    takenBy: this.props.auth.uid,
                                                    takenByCompany: this.props.profile.companyId,
                                                    taken: true,
                                                })
                                            this.props.firestore.collection('companies').doc(this.props.profile.companyId)
                                                .collection('takenCalls').add({
                                                takeDate: new Date(),
                                                employeeId: this.props.auth.uid,
                                                callId: e.id,
                                            })
                                        }}>take</button>
                                    </li>
                                )
                            }



                        })}
                    </ul>
                    :
                    <div>No active call</div>
                }
            </div>
        );
    }
}

export default compose(
    withRouter,
    withFirestore,
    connect(
        ({firebase: {auth, profile}}) => ({
            auth,
            profile
        })
    ),
    firestoreConnect([{
        collection: CALL_DB_PATH,
        where: [
            ['active', '==', true],
            ['taken', '==', false],
            ['takenByCompany', '==', ''],

        ],
    }]),
    connect((state, props) => ({
        calls: state.firestore.ordered[CALL_DB_PATH]
    })),
    UserIsAuthenticated,
    withSubscriptionValidatorHoc,
)(ActiveCalls);